<template>
  <div class="music-page">
    <!-- 背景视频（只保留视频） -->
    <div class="bg-video-wrapper">
      <video
        class="bg-video"
        autoplay
        loop
        muted
        playsinline
        @canplay="onVideoLoaded"
      >
        <source src="/img/home_video.mp4" type="video/mp4" />
      </video>
      <!-- 轻量遮罩层（只为了让文字更清晰） -->
      <div class="video-mask"></div>
    </div>

    <!-- 固定顶部导航栏 -->
    <div class="fixed-nav">
      <van-nav-bar class="nav-bar" :title="$t('auth.top6')">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" @click="onClickLeft()" />
        </template>
      </van-nav-bar>
    </div>

    <!-- 内容区域 -->
    <div class="music-content">
      <!-- 顶部播放器信息 -->
      <div class="player-header">
        <div class="cover-grid">
          <img 
            :src="data[0] && data[0].img_url" 
            class="grid-cover" 
            v-if="data.length > 0" 
          />
          <img 
            :src="data[1] && data[1].img_url" 
            class="grid-cover" 
            v-if="data.length > 1" 
          />
          <img 
            :src="data[2] && data[2].img_url" 
            class="grid-cover" 
            v-if="data.length > 2" 
          />
          <img 
            :src="data[3] && data[3].img_url" 
            class="grid-cover" 
            v-if="data.length > 3" 
          />
        </div>
        <div class="player-right">
          <div class="playlist-name">{{$t('auth.top43')}}</div>
          <div class="playlist-author">{{$t('auth.top44')}}</div>
        </div>
      </div>

      <!-- 歌曲列表 - 自动无限轮播（占满剩余高度） -->
      <div class="song-list-container">
        <div class="song-list" :style="{ transform: `translateY(-${currentIndex * itemHeight}px)` }">
          <div 
            class="song-item" 
            v-for="(item, index) in displayList" 
            :key="index" 
          >
            <div class="song-index">{{ (index % data.length) + 1 }}</div>
            
            <div class="song-info">
              <img 
                v-if="item.img_url" 
                :src="item.img_url" 
                class="song-thumb" 
                alt=""
              />
              <div class="song-text">
                <div class="song-name">{{ item.xuanfei_name }}</div>
                <div class="song-artist">{{ item.bust }}</div>
              </div>
            </div>

            <div class="song-duration">
              <van-icon name="play-circle-o" size="14PX" color="rgba(255,255,255,0.85)" />
              <span v-if="item.danwei==1">{{ item.dianzan }}{{$t('auth.top42')}}</span>
              <span v-else>{{ item.dianzan }}{{$t('auth.top41')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      page: 0,
      ids: 1,
      currentIndex: 0,
      timer: null,
      itemHeight: 56,
      videoLoaded: false
    };
  },
  computed: {
    displayList() {
      return [...this.data, ...this.data];
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onVideoLoaded() {
      this.videoLoaded = true;
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: this.ids, home_class: 2, page: this.page }
      }).then((res) => {
        this.data = res.data;
        const lanng = localStorage.getItem("lang") || "zh";
        this.data.forEach((item) => {
          if (item.flag) {
            const parts = item.flag.split("|");
            lanng == "zh"
              ? (item.flag = parts[0])
              : lanng == "en"
              ? (item.flag = parts[1])
              : lanng == "ja"
              ? (item.flag = parts[2])
              : (item.flag = parts[3]);
          }
        });
      });
    },
    playSong(item) {
      this.$toast('正在播放：' + item.name);
    },
    startScroll() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.currentIndex++;
        if (this.currentIndex >= this.data.length) {
          this.currentIndex = 0;
        }
      }, 3000);
    },
    pauseScroll() {
      clearInterval(this.timer);
    },
    resumeScroll() {
      this.startScroll();
    }
  },
  mounted() {
    this.startScroll();
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  created() {
    this.getxuanfeilist();
  }
};
</script>

<style lang="less" scoped>
.music-page {
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 背景视频 */
.bg-video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}

.bg-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 轻量遮罩层（只让文字更清晰） */
.video-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg, 
    rgba(0, 0, 0, 0.3) 0%, 
    rgba(0, 0, 0, 0.1) 50%, 
    rgba(0, 0, 0, 0.3) 100%
  );
}

/* 固定顶部导航栏 */
.fixed-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: transparent;
}

/* 顶部导航栏 */
.nav-bar {
  background: transparent !important;
  height: 50PX;
  flex-shrink: 0;
  :deep(.van-nav-bar__title) {
      color: #fff !important;
      font-size: 18PX;
      font-weight: 600;
      text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
    }
    :deep(.van-icon) {
      color: #fff;
      text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
    }
}

/* 内容区域（几乎透明，让视频清晰可见） */
.music-content {
  flex: 1;
  padding: 70PX 20PX 60PX;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.05); /* 几乎透明 */
  display: flex;
  flex-direction: column;
}

.player-header {
  display: flex;
  align-items: center;
  margin-bottom: 10PX;
  flex-shrink: 0;
}

.playlist-name {
  font-size: 20PX;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.1);
}

.playlist-author {
  font-size: 14PX;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 8PX;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
}

.cover-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 2PX;
  width: 80PX;
  height: 80PX;
  border-radius: 8PX;
  overflow: hidden;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.grid-cover {
  width: 40PX;
  height: 40PX;
  object-fit: cover;
}

.player-right {
  flex: 1;
  margin-left: 15PX;
}

/* 歌曲列表容器（降低不透明度，让背景透出来） */
.song-list-container {
  margin-top: 15PX;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.1); /* 降低到 0.3 */
  border-radius: 12PX;
  box-shadow: 0 4PX 16PX rgba(0, 0, 0, 0.1);
}

.song-list {
  transition: transform 0.5s ease;
}

.song-item {
  display: flex;
  align-items: center;
  height: 56PX;
  padding: 0 10PX;
  cursor: pointer;
}

.song-item:hover {
  background: rgba(255, 255, 255, 0.15);
}

.song-index {
  width: 30PX;
  font-size: 18PX;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  flex-shrink: 0;
}

.song-info {
  flex: 1;
  margin-left: 10PX;
  display: flex;
  align-items: center;
  height: 56PX;
  overflow: hidden;
}

.song-thumb {
  width: 40PX;
  height: 40PX;
  object-fit: cover;
  border-radius: 6PX;
  flex-shrink: 0;
  box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.1);
}

.song-text {
  margin-left: 10PX;
  flex: 1;
  overflow: hidden;
}

.song-name {
  font-size: 15PX;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 1PX 2PX rgba(0, 0, 0, 0.1);
}

.song-artist {
  font-size: 13PX;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 2PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 1PX 2PX rgba(0, 0, 0,0.1);
}

.song-duration {
  font-size: 13PX;
  color: rgba(255, 255, 255, 0.85);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4PX;
  text-shadow: 0 1PX 2PX rgba(0, 0, 0, 0.1);
}
::v-deep .van-nav-bar__title {
  color: #fff !important;
  font-size: 18PX;
  font-weight: 600;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.1);
}

::v-deep .van-nav-bar__text {
  color: #fff !important;
}
</style>